import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { Link } from "react-router-dom";
import { usePublicSiteContent } from "../../hooks/useSiteContent";
import { whatsappUrl } from "../../lib/siteContentStore";

const values = [
  { icon: "ri-shield-check-line", title: "Güvenilir Süreç", desc: "Siparişten teslimata kadar süreç açık, düzenli ve takip edilebilir şekilde yürütülür." },
  { icon: "ri-drop-line", title: "Hijyenik Kesim", desc: "Kesim ve parçalama aşamalarında temizlik, düzen ve zamanlama önceliğimizdir." },
  { icon: "ri-hand-heart-line", title: "Helal Hassasiyet", desc: "Kurbanlık ve adaklık işlemleri dini hassasiyetler gözetilerek planlanır." },
  { icon: "ri-whatsapp-line", title: "Doğrudan İletişim", desc: "Kayıt ve bilgi süreçleri WhatsApp üzerinden kontrollü şekilde ilerletilir." },
];

export default function AboutPage() {
  const content = usePublicSiteContent();

  return (
    <div className="min-h-screen bg-farm-cream font-body">
      <Navbar />
      <section className="relative overflow-hidden bg-farm-cream px-4 pt-14 pb-16">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_84%_10%,rgba(184,134,90,0.14),transparent_34%)]" />
        <div className="relative max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-8 items-center">
          <div>
            <span className="font-body text-xs font-bold tracking-[0.24em] text-farm-earth">HAKKIMIZDA</span>
            <h1 className="mt-3 font-heading text-4xl md:text-5xl font-bold text-farm-brown leading-tight">
              Evren Çiftliği’nde düzenli, güvenilir ve şeffaf hizmet
            </h1>
            <p className="mt-5 font-body text-base text-farm-muted leading-relaxed">
              Kurbanlık, adaklık, hisseli satış, kesim ve teslimat süreçlerini sade, anlaşılır ve takip edilebilir bir yapıda sunuyoruz.
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a href={whatsappUrl(content)} target="_blank" rel="nofollow noopener" className="inline-flex items-center justify-center gap-2 rounded-2xl bg-farm-green px-6 py-3 text-white font-body font-bold hover:bg-farm-green/90 transition-colors">
                <i className="ri-whatsapp-line text-xl" /> WhatsApp ile Bilgi Al
              </a>
              <Link to="/hizmetler" className="inline-flex items-center justify-center gap-2 rounded-2xl border border-farm-earth/30 bg-farm-warm px-6 py-3 text-farm-brown font-body font-bold hover:bg-farm-earth-light transition-colors">
                Hizmetleri İncele <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
          <div className="rounded-[28px] border border-farm-border bg-farm-warm p-4 shadow-sm">
            <img src={content.hero.imageUrl} alt="Evren Çiftliği" className="h-[360px] w-full rounded-[22px] object-cover object-center" />
          </div>
        </div>
      </section>

      <section className="bg-farm-warm py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-2xl mb-9">
            <span className="font-body text-xs font-bold tracking-[0.24em] text-farm-earth">İLKELERİMİZ</span>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl font-bold text-farm-brown">Sade ama ciddi bir hizmet anlayışı</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {values.map((value) => (
              <div key={value.title} className="rounded-[28px] border border-farm-border bg-farm-cream p-7 shadow-sm">
                <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-farm-earth-light text-farm-brown"><i className={`${value.icon} text-3xl`} /></div>
                <h3 className="mt-5 font-heading text-2xl font-bold text-farm-brown">{value.title}</h3>
                <p className="mt-2 font-body text-sm text-farm-muted leading-relaxed">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
